import LoginForm from "../components/LoginForm";
import "./styles/LoginPage.css";

const LoginPage = () => {
  return (
    <div className="login_page_container">
      <LoginForm />
    </div>
  );
};

export default LoginPage;
